import { render, staticRenderFns } from "./TaskCreateDialog.vue?vue&type=template&id=3ee45d80&"
import script from "./TaskCreateDialog.vue?vue&type=script&lang=js&"
export * from "./TaskCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports